import { render, staticRenderFns } from "./ClueDetail.vue?vue&type=template&id=078b2ec6&scoped=true"
import script from "./ClueDetail.vue?vue&type=script&lang=js"
export * from "./ClueDetail.vue?vue&type=script&lang=js"
import style0 from "./ClueDetail.vue?vue&type=style&index=0&id=078b2ec6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078b2ec6",
  null
  
)

export default component.exports